import { compose } from '@reduxjs/toolkit';
import { loadAddressesAction, loadAddressesReducer } from './loadAddresses';

export const extraReducers = compose(loadAddressesReducer);
export { loadAddressesAction };
